import hy from "./json/hy.json";
import pl from "./json/pl.json";
import en from "./json/en.json";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  hy,
  pl,
  en,
};
